import {Component, Input, OnInit, OnDestroy, Renderer2} from '@angular/core';
import {LotteriesService} from '../../lotteries.service';
import * as globals from '../../settings';
import {Event} from '@angular/router';
import {SubscriptionsService} from '../../_services/subscriptions.service';
import {Subscription} from 'rxjs';
import {CurrencyService} from '../../_services/currency.service';
import {UserService} from '../../_services/user.service';

@Component({
    selector: 'app-scratch-home',
    templateUrl: './scratch-home.component.html',
    styleUrls: ['./scratch-home.component.scss']
})
export class ScratchHomeComponent implements OnInit, OnDestroy {
    homeScratch: any;
    homeScratch_tmp: any;
    itemsSize: number;
    selectedBox: any;
    amountArray: any;
    selectedBoxTicket: any;
    gamePrice: any;
    DiscountForMultiPrice: any;
    discount: any;
    DiscountAmount: any;
    visible: boolean;
    languageChange: any;
    showLang: any;
    checkoutId: number;
    checkoutTickets: number;
    runScratchCheckout: number;
    myScratch: any[];
    runCheckout: boolean;
    changedCurrency: Subscription;
    currency: any;
    afterComma = globals.afterComma;
    brand = globals.brand;
    isLoadingButtonIndex: any;
    finishedAddScratch: Subscription;

    constructor(public lotteryService: LotteriesService,
                public subscriptionsService: SubscriptionsService,
                public userService: UserService,
                public currencyService: CurrencyService,
                private renderer: Renderer2) {
        this.languageChange = this.subscriptionsService.getLanguage().subscribe(lang => {
            this.showLang = lang;
        });
        this.runCheckout = false;
        this.visible = false;
        this.runScratchCheckout = 0;
        this.isLoadingButtonIndex = false;
        this.lotteryService.getLotteries(
            globals.appDomain + '/ScratchCards/getGameCategories/scratchCategories_home.json').subscribe(
            result => {
                if (result.message) {
                    this.lotteryService.getLotteries(
                        globals.appDomain + '/ScratchCards/getGamePackages/getGamePackages_home.json').subscribe(
                        res => {
                            this.homeScratch_tmp = [];
                            if (res) {
                                this.myScratch = res;
                                const homepage = result.message.filter((el) => this.isHomepageCat(el));
                                homepage[0].Packages.forEach((ele) => {
                                    res.forEach((elem) => {
                                        if (parseInt(elem.PackageID, 10) === ele) {
                                            this.homeScratch_tmp.push(elem);
                                        }
                                    });
                                });
                                this.homeScratch = this.homeScratch_tmp;

                                if (this.homeScratch) {
                                    this.homeScratch.forEach((elem) => {
                                        const toCheck = 0;
                                        elem.DiscountForMultiPrice = [];
                                        elem.DiscountAmount = [];
                                        elem.DiscountDefault = [];
                                        elem.DiscountPrice = [];
                                        if (elem.ProductType === 'game') {
                                            elem.PackageMultiTickets.forEach((el) => {
                                                const price = el.Tickets * +el.Rates.Price[this.currency.Code];
                                                const FixedPrice = price.toFixed(2);
                                                elem.DiscountForMultiPrice[elem.PackageMultiTickets.indexOf(el)] = FixedPrice;
                                                elem.DiscountAmount[elem.PackageMultiTickets.indexOf(el)] = el.Discount;
                                                elem.DiscountDefault[elem.PackageMultiTickets.indexOf(el)] = el.IsDefault;
                                                elem.DiscountPrice[elem.PackageMultiTickets.indexOf(el)] = ((elem.OnlinePrice * 1) - (
                                                    (elem.OnlinePrice * 1) * (el.Discount * 1) / 100)).toFixed(2);
                                                if (el.IsDefault === '1') {
                                                    this.pickQuantity(this.homeScratch.indexOf(elem),
                                                        elem.PackageMultiTickets.indexOf(el),
                                                        elem.PackageMultiTickets[elem.PackageMultiTickets.indexOf(el)].Tickets);
                                                }
                                            });
                                        }
                                    });
                                    this.visible = true;
                                }
                            }
                        });
                }
            });
        this.currency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.currency = currency;
            }
        });

        this.finishedAddScratch = this.subscriptionsService.getFinishedLoadingOnScratchHomepage().subscribe(data => {
            if (data) {
                this.isLoadingButtonIndex = false;
            }
        });
    }

    isHomepageCat(elem) {
        if (elem.Name === 'Homepage') {
            return elem;
        }
    }

    ngOnInit() {
        this.itemsSize = 4;
        this.selectedBox = [];
        this.selectedBoxTicket = [];
        this.amountArray = [];
        this.gamePrice = [];
        this.discount = [];
        this.showLang = localStorage.getItem('pageLanguage');

    }

    ngOnDestroy() {
        if (this.languageChange) {
            this.languageChange.unsubscribe();
        }
        if (this.changedCurrency) {
            this.changedCurrency.unsubscribe();
        }
    }

    pickQuantity(index, index2, discount) {
        this.amountArray[index] = [];
        this.amountArray[index] = discount;
        this.selectedBox[index] = index2;
        this.selectedBoxTicket[index] = this.homeScratch[index].PackageMultiTickets[index2].Tickets;
        this.gamePrice[index] = [];
        this.gamePrice[index].push(this.homeScratch[index].DiscountForMultiPrice[index2]);
        this.discount[index] = this.homeScratch[index].DiscountAmount[index2];
    }

    playThisScratch(tickets, id) {
        this.isLoadingButtonIndex = tickets;
        if (!this.userService.userData) {
            this.subscriptionsService.triggerAddToCartScratch({
                tickets: tickets,
                id: id,
                amountArray: this.amountArray,
                runCheckout: true,
                myScratch: this.myScratch
            });
        }
        this.renderer.addClass(document.body, 'modal-open');
        this.subscriptionsService.updateRunScratchcardCheckout({
            tickets: tickets,
            id: id,
            amountArray: this.amountArray,
            runCheckout: true,
            myScratch: this.myScratch
        });
    }


}
